import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, InputGroup, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import colors from '../../constants/colors';
import {
  FaInfoCircle,
  FaBox,
  FaShieldAlt,
  FaEnvelope,
  FaArrowCircleUp,
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaCalendar,
  FaBook
} from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState({
    show: false,
    message: '',
    variant: ''
  });
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.post('/newsletter', { email });
      setSubscribeStatus({
        show: true,
        message: 'Olá! Obrigada pela tua subscrição. Para não perderes nada, faz já a confirmação no teu email! Até já!',
        variant: 'success'
      });
      setEmail('');
    } catch (error) {
      setSubscribeStatus({
        show: true,
        message: error.response?.data?.message || 'Erro ao inscrever. Tente novamente.',
        variant: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer style={{ backgroundColor: colors.primary, color: colors.dark, padding: '3rem 0' }}>
      <Container>
        <Row>
          <Col lg={4} md={6} className="mb-4 mb-md-0 text-center text-md-start">
            <h5 className="text-uppercase mb-4">Mapa do Site</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/sobre"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaInfoCircle className="me-2" />Sobre Nós
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/produtos"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaBox className="me-2" />Produtos
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/termos-privacidade"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaShieldAlt className="me-2" />Termos e Privacidade
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contactos"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaEnvelope className="me-2" />Contactos
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/servicos"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaCalendar className="me-2" />Serviços
                </Link>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.livroreclamacoes.pt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: colors.dark, textDecoration: 'none' }}
                >
                  <FaBook className="me-2" />Livro de Reclamações
                </a>
              </li>
            </ul>
          </Col>

          <Col lg={4} md={6} className="mb-4 mb-md-0 text-center d-flex flex-column justify-content-between">
            <div>
              <figure>
                <blockquote className="blockquote">
                  <p>"Não é sobre ter a casa perfeita, é sobre sentir que a casa te dá espaço para viver."</p>
                </blockquote>
              </figure>
            </div>

            <Button
              variant="outline-light"
              className="mt-4"
              onClick={scrollToTop}
              style={{ backgroundColor: colors.secondary, color: colors.light, borderColor: colors.secondary }}
            >
              <FaArrowCircleUp className="me-2" />
              Voltar ao Topo
            </Button>
          </Col>

          <Col lg={4} className="mt-4 mt-lg-0 text-center">
            <h5 className="text-uppercase mb-4">Mantém-te Conectado</h5>

            <div className="mb-4">
              <div className="d-flex justify-content-center" style={{ width: '80%', margin: '0 auto' }}>
                <a
                  href="https://www.facebook.com/marciamaio.organiza"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook size="1.5em" />
                </a>
                <div className="flex-grow-1"></div>
                <a
                  href="https://www.instagram.com/marciamaio.organiza"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size="1.5em" />
                </a>
                <div className="flex-grow-1"></div>
                <a
                  href="https://www.tiktok.com/@marciamaio.organiza"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok size="1.5em" />
                </a>
              </div>
            </div>

            <h5 className="text-uppercase mb-3">Newsletter</h5>
            {subscribeStatus.show && (
              <Alert
                variant={subscribeStatus.variant}
                onClose={() => setSubscribeStatus({ ...subscribeStatus, show: false })}
                dismissible
              >
                {subscribeStatus.message}
              </Alert>
            )}
            <Form onSubmit={handleNewsletterSubmit}>
              <InputGroup className="mb-3">
                <Form.Control
                  placeholder="O teu email"
                  aria-label="Email para newsletter"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
                <Button
                  variant="light"
                  type="submit"
                  disabled={loading}
                  style={{ cursor: loading ? 'not-allowed' : 'pointer', backgroundColor: colors.secondary, color: colors.light }}
                >
                  {loading ? (
                    <Spinner className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                  ) : (
                    'Subscrever'
                  )}
                </Button>
              </InputGroup>
            </Form>
          </Col>
        </Row>

        <hr style={{ borderColor: colors.dark }} className="my-4" />

        <Row>
          <Col className="text-center">
            <p className="small mb-0">
              © {new Date().getFullYear()} Márcia Maio. Todos os direitos reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
